import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { splitMailBody } from "../utils/mailBody";

/**
 * Treść maila: to, co ktoś napisał, na wierzchu — poprzednia korespondencja
 * schowana pod jednym przyciskiem, jak w każdym normalnym kliencie poczty.
 */
export function AronMailBody({ text }: { text: string }) {
  const { body, quoted } = splitMailBody(text);
  const [showQuoted, setShowQuoted] = useState(false);

  return (
    <div className="text-sm">
      <div className="whitespace-pre-wrap leading-relaxed text-gray-800 dark:text-gray-200">
        {body || "(pusta treść)"}
      </div>
      {quoted && (
        <div className="mt-3">
          <button
            type="button"
            onClick={() => setShowQuoted((v) => !v)}
            className="inline-flex items-center gap-1 border border-gray-200 px-1.5 py-0.5 font-mono text-[10px] tracking-wide text-gray-500 uppercase transition-colors hover:border-gray-400 hover:text-gray-700 dark:border-gray-700 dark:hover:text-gray-200"
          >
            {showQuoted ? <ChevronDown size={11} /> : <ChevronRight size={11} />}
            Wcześniejsza korespondencja
          </button>
          {showQuoted && (
            <div className="mt-2 border-l-2 border-gray-200 pl-3 whitespace-pre-wrap text-xs leading-relaxed text-gray-500 dark:border-gray-700 dark:text-gray-400">
              {quoted}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
